/**
 * A 404 from our own API means one of two things. With no envelope it is a
 * route the running server does not have, which is a developer's problem and
 * `describeApiFailure` says so. With the server's envelope (a code and a
 * sentence) the route answered, and what it did not find is a row: an entry
 * that never reached the server, say. That one is the server's own sentence.
 *
 * Pure, and apart from `failure-messages.ts`, because that module reaches the
 * network layer and this decision is worth a test.
 */
type Failure = { readonly status?: unknown; readonly code?: unknown; readonly message?: unknown };

export const missingRow = (failure: unknown): string | null => {
  if (typeof failure !== 'object' || failure === null) return null;
  const { status, code, message } = failure as Failure;
  if (status !== 404 || typeof code !== 'string' || code === '') return null;
  return typeof message === 'string' && message.trim() !== '' ? message.trim() : null;
};
